import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className, ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0.25, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.6, ease: "easeOut", delay: reduce ? 0 : delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};
